import {useContext} from "react";
import {ToastContext} from "../Contexts";
import {
    FrontendEntityChangeListResponse,
    ToastFailureMessage, ToastSuccessMessage,
} from "../Models/Models";
import HttpRepository from "./HttpRepository";

export function FrontendEntityChangeService() {
    let {setToast}: any = useContext(ToastContext);

    async function getChanges(websiteId: number): Promise<FrontendEntityChangeListResponse> {
        try {
            return (await HttpRepository.getFrontendEntityChnages(websiteId)).data;
        } catch (error) {
            setToast({message: ToastFailureMessage.dataNotLoaded});
        }
    }

    async function syncChanges(websiteId: number): Promise<void> {
        try {
            await HttpRepository.syncFrontendEntityChanges(websiteId);
            setToast({message: ToastSuccessMessage.synced})
        } catch (error) {
            setToast({message: ToastFailureMessage.changesNotSynced});
        }
    }

    return {getChanges, syncChanges}
}